<template>
  <div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column type="index" width="50" :index="index"></el-table-column>
      <el-table-column prop="label" label="类型" sortable="custom"></el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleSelect(scope.row)" type="text" size="small">添加</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tableData: [
        {id: 0, type: 'fy_word', label: '词汇'},
        {id: 0, type: 'fy_grammar', label: '语法'},
        {id: 0, type: 'fy_kewen', label: '课文'},
        {id: 0, type: 'fy_test', label: '小测试'},
        {id: 0, type: 'fy_training', label: '综合训练'},
      ],
    }
  },
  methods: {
    handleSelect (val) {
      this.$emit('change', {
        type: val.type,
        entity: val
      })
    }
  }
}
</script>